var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{staticClass:"p-3"},[_c('kendo-grid',{ref:"grid",attrs:{"data-source":_vm.ddlData,"pageable":true,"filterable":true,"sortable":true,"scrollable":true,"columns":_vm.columns,"editable":true,"resizable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }